// Put all the handlebars helpers here

import Handlebars from "handlebars/dist/handlebars";

export function hbsHelpers() {

    // Used to generate dates for iCal
    // e.g. 20220601T030200
    Handlebars.registerHelper('iCalDates', function (instanceObj, options) {
   
        let icalDates = {};
   
        // Make YYYY-MM-DD into YYYYMMDD
        const formattedStartDateString = instanceObj.date.replace(/-/g, '');
        
        const formattedStartTimeString = `${instanceObj.start.replace(/:/g, '')}00`;
        const formattedEndTimeString = `${instanceObj.end.replace(/:/g, '')}00`;
        
        icalDates.dtstart = `${formattedStartDateString}T${formattedStartTimeString}`;
        
        
        if (formattedStartTimeString < formattedEndTimeString) {
            
            icalDates.dtend = `${formattedStartDateString}T${formattedEndTimeString}`;
            
        } else {
            
            // e.g. Event started at 22:00 but finished at 02:00
            
            // Increase by one day
            let endDateObj = new Date(instanceObj.date);
        
            endDateObj.setDate(endDateObj.getDate() + 1);
            
            // Make date object back into YYYY-MM-DD
            const endDateString = new Date(endDateObj.getTime() - (endDateObj.getTimezoneOffset() * 60000)).toISOString().substring(0,10);
            
            // Make YYYY-MM-DD into YYYYMMDD
            const formattedEndDateString = endDateString.replace(/-/g, '');
            
            icalDates.dtend = `${formattedEndDateString}T${formattedEndTimeString}`;
            
        }
        
        return options.fn(icalDates);
        
    });

    // Escape comma and semicolon for iCal Location. If not escape, location breaks at first , or ; when imported into iCalendar
    Handlebars.registerHelper('iCalEscape', function (string) {
        
        const regex = /(,|;)/g;
        
        return string.replace(regex, '\\$1');
        
    });

    Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

        switch (operator) {
            case '==':
                return (v1 == v2) ? options.fn(this) : options.inverse(this);
            case '===':
                return (v1 === v2) ? options.fn(this) : options.inverse(this);
            case '!=':
                return (v1 != v2) ? options.fn(this) : options.inverse(this);
            case '!==':
                return (v1 !== v2) ? options.fn(this) : options.inverse(this);
            case '<':
                return (v1 < v2) ? options.fn(this) : options.inverse(this);
            case '<=':
                return (v1 <= v2) ? options.fn(this) : options.inverse(this);
            case '>':
                return (v1 > v2) ? options.fn(this) : options.inverse(this);
            case '>=':
                return (v1 >= v2) ? options.fn(this) : options.inverse(this);
            case '&&':
                return (v1 && v2) ? options.fn(this) : options.inverse(this);
            case '||':
                return (v1 || v2) ? options.fn(this) : options.inverse(this);
            default:
                return options.inverse(this);
        }
    });

    Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
        return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
    });

    Handlebars.registerHelper('ifNotLive', function (statusCode, options) {
        
        switch(statusCode) {
            
            case "2":
            case "4":
            case "8":
                return options.fn(this);        
                break;
                
        }
        
    });

    Handlebars.registerHelper('ifEditable', function (statusCode, options) {
        
        switch(statusCode) {
            
            case "2":
            case "16":
            case "64":
            case "32":
                return options.fn(this);        
                break;
                
        }
        
    });

    Handlebars.registerHelper('ifLive', function (statusCode, options) {
        
        switch(statusCode) {
            
            case "16":
            case "32":
                return options.fn(this);        
                break;
                
        }
        
    });

    Handlebars.registerHelper('ifSafeEdit', function (statusCode, options) {
        
        switch(statusCode) {
            
            case "64":
            case "128":
            case "256":
                return options.fn(this);        
                break;
                
        }
        
    });

    Handlebars.registerHelper('ifApproved', function (statusCode, options) {
        
        switch(statusCode) {
            
            case "8":
            case "256":
                return options.fn(this);        
                break;
                
        }
        
    });

    Handlebars.registerHelper('ifScheduledPublish', function (scheduledPublishType, scheduledPublishDate, options) {
        
        if (scheduledPublishType === "Schedule for later" && scheduledPublishDate) {
            return options.fn(this);    
        }
        
    });

    Handlebars.registerHelper ('truncate', function (str, len) {
        if (str && str.length > len) {
            var new_str = str.substr (0, len+1);

            while (new_str.length) {
                var ch = new_str.substr ( -1 );
                new_str = new_str.substr ( 0, -1 );

                if (ch == ' ') {
                    break;
                }
            }

            if ( new_str == '' ) {
                new_str = str.substr ( 0, len );
            }

            return new Handlebars.SafeString ( new_str +'...' ); 
        }
        return str;
    });
    
    Handlebars.registerHelper('formatDate', function (dateString, format) {
        
        if (dateString) {

            const months = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ]
        
            const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            
            let year = dateString.substring(0,4);
            let month = dateString.substring(5,7);
            let day = Number(dateString.substring(8,10));
            
            let dateObj = new Date(year, month - 1, day);
            
            if (format =="myEventsDayMonth") {
                
                return `<span class="my-events__item-date-first-day">${day < 10 ? `0${day}` : day}</span> ${months[month - 1]}`;
                
            } else {
                
                // Default format of Day Name, Day, Month, Year
                return `${days[dateObj.getDay()]}, ${day < 10 ? `0${day}` : day} ${months[month - 1]} ${year}`;    
                
            }

        }
        
    });

    Handlebars.registerHelper('convertTime24to12', function (timeString24hr) {
   
        const timeString12hr = new Date(`1970-01-01 ${timeString24hr}`).toLocaleTimeString('en-AU',
        {hour12: true, hour:'numeric', minute:'numeric'});
       
        return timeString12hr.toUpperCase();
        
    });

    Handlebars.registerHelper('formatLocation', function (venueName, venueStreet, venueSuburb, venuePostCode) {
        
        let location = "";
        
        if (venueName) {
            
            location += venueName;
            
            if (venueStreet) {
                location += ", ";
            }
            
        }
        
        if (venueStreet) {
            
            location += `${venueStreet}, ${venueSuburb}, QLD ${venuePostCode}`;
            
        }
        
        return location;
        
    });

    Handlebars.registerHelper('formatStatus', function (statusCode) {
    
    switch(statusCode) {
        
            case "1":
                return "Archived";
                break;
            case "2":
                return "Draft";
                break;
            case "4":
                return "Pending approval";
                break;
            case "8":
                return "Approved";
                break;
            case "16": 
                return "Published";
                break;
            case "32":
                return "Up for review";
                break;
            case "64":
                return "Draft changes";
                break;
            case "128":
                return "Changes pending approval";
                break;
            case "256":
                return "Changes approved";
                break;
            
    }
        
    });

    Handlebars.registerHelper('getYouTubeID', function (url) {

        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        
        const match = url.match(regExp);
        
        return (match&&match[7].length==11)? match[7] : "";

    });

}
